import { object, string, boolean } from 'yup';

export const subscribeFormSchema = object({
	Email: string().trim().email('Please enter a valid e-mail').max(254, 'E-mail is too long').required('E-mail is a required field'),
	Theme: string().default('None'),
	AGREEMENT: boolean()
		.oneOf([true], 'Agreement is required')
		.required('Agreement is required'),
	TYPE_FORM: string().default('subscribe'),
	PORTFOLIO: string().default('Noord'),
});
